module.exports = __webpack_public_path__ + "static/5_3-gan-dbb4be55da9397e31edac559320b0fec.svg";